import { Component, DestroyRef, input, OnInit, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Country } from '@app/core/stingray-api/models';
import { finalize, map } from 'rxjs/operators';
import { CountryAutoCompleteService } from './country-autocomplete.service';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'unite-country-autocomplete',
    templateUrl: './country-autocomplete.component.html',
    styleUrls: ['./country-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressSpinner, MatSuffix, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule]
})
export class CountryAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  appearance = input<string>('outline');
  class = input<string>(null);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();

  countries: Country[] = [];
  countriesFiltered: Country[];

  isLoadingCountries = false;

  constructor(
    private countryAutoCompleteService: CountryAutoCompleteService) { }

  ngOnInit() {
    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.isLoadingCountries = true;
    this.countryAutoCompleteService.getCountries().pipe(
      finalize(() => {
        this.isLoadingCountries = false;
      })
    ).subscribe((customers: Country[]) => {
      this.countries = customers;
      this.countriesFiltered = customers;
    });

    this.control().valueChanges.pipe(
      map((value: string | Country) => {
        if (this.isCountry(value)) {
          return this.filterCountry(value.name);
        } else {
          return this.filterCountry(value || '');
        }
      }), takeUntilDestroyed(this.destroyRef)
    ).subscribe((countries: Country[]) => {
      this.countriesFiltered = countries;
    });
  }

  displayWithCountry(country: Country): string {
    if (country != null) {
      return country.name;
    } else {
      return '';
    }
  }

  filterCountry(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter((country: Country) => {
      return this.displayWithCountry(country).toLowerCase().includes(filterValue) ||
        country.code.toLowerCase().includes(filterValue);
    });
  }

  isCountry(value: any | Country): value is Country {
    return value != null && (<Country>value).code !== undefined;
  }
}
